const routeCategory = () => '/category';

export default routeCategory;
